import { Tooltip } from 'components/Blocks';

import { formatDate, differenceInDays } from 'utils/date';
import { cascadeEval } from 'utils/conditions';
import { cn } from 'styles';

interface ExpectedDateProps {
  date?: string;
  isActive?: boolean;
  className?: string;
}

function getDaysLeft(expectedDate?: string) {
  if (!expectedDate) return 0;

  return differenceInDays(new Date(expectedDate), new Date());
}

function getDateColor(expectedDate?: string) {
  if (!expectedDate) return '';

  const daysLeft = getDaysLeft(expectedDate);

  const color = cascadeEval([
    { is: daysLeft > 0, then: 'text-muted-foreground' },
    { is: daysLeft === 0, then: 'text-warning' },
    { is: true, then: 'text-destructive' },
  ]);

  return color;
}

export function ExpectedDate({ date, isActive, className }: ExpectedDateProps) {
  return (
    <Tooltip disabled={!date || !isActive} content={`${getDaysLeft(date)} days left`}>
      <span className={cn(isActive ? getDateColor(date) : 'text-inherit', className)}>
        {date ? formatDate(date, 'dd/mm/yyyy') : '-'}
      </span>
    </Tooltip>
  );
}
